export default __webpack_public_path__ + "343f5069ef6d73e439b4d5d4a7636f8d.png";